import classNames from 'classnames';
import { graphql } from 'gatsby';
import { Button } from 'hem-ui';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import React from 'react';

import { fixSlug } from './RichText';
import { root } from './RichTextButton.module.scss';

const RichTextButton: React.FC<{
  node: { data: { target: Queries.RichTextButtonFragment } };
}> = ({ node }) => {
  const entry = get(node, 'data.target');

  if (!entry) {
    console.warn('[RichTextButton] Entry not rendered', { node });
    return null;
  }

  if (isEmpty(entry.link)) {
    return null;
  }

  let slug = null;
  switch (entry.link?.__typename) {
    case 'ContentfulPageProduct':
      slug = entry.link.defaultVariant?.slug;
      break;
    case 'ContentfulLink':
      slug = entry?.link?.slug || entry?.link?.entry?.slug;
      break;
    case 'ContentfulPage':
    case 'ContentfulPageArticle':
    case 'ContentfulPageCategory':
    case 'ContentfulPageDepartment':
    case 'ContentfulPageDesigner':
    case 'ContentfulPageSubcategory':
    case 'ContentfulProductVariant':
      slug = entry.link.slug;
      break;
  }

  if (!slug) {
    console.warn('[RichTextButton] Entry not rendered', { node });
    return null;
  }

  return (
    <div className={root}>
      <Button
        to={fixSlug(slug)}
        className={classNames({
          'mx-auto block': entry.align === 'center',
        })}
        // @ts-expect-error color prop matches in Contentful, but types doesn't propegate
        color={entry.color}
      >
        {entry.text}
      </Button>
    </div>
  );
};

export default RichTextButton;

export const query = graphql`
  fragment RichTextButton on ContentfulComponentButton {
    __typename
    contentful_id
    ...Button
  }
`;
